import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
@Component({
  selector: 'app-idpguys',
  templateUrl: './idpguys.component.html',
  styleUrls: ['./idpguys.component.css']
})
export class IDPGuysComponent implements OnInit {

  public footers = [
    { 'title': 'About', 'description': 'About Description', 'path': 'about' },
    { 'title': 'Blog', 'description': '', 'path': '' },
    { 'title': 'FAQ', 'description': 'faq Description', 'path': 'faq' },
    { 'title': 'Rules', 'description': 'rules Description', 'path': 'rules' },
    { 'title': 'Support', 'description': 'welcomeSupport Description', 'path': 'welcomeSupport' },
    { 'title': 'Terms & Conditions', 'description': 'legal Description', 'path': 'legal' },
    { 'title': 'Privacy Policy', 'description': 'privacyPolicy Description', 'path': 'privacyPolicy' }
  ];

  constructor(public router: Router) { }

  navigateToSignup() {
    localStorage.setItem("isFrom", "idpguys")
    this.router.navigateByUrl("/landing/signup")
  }


  ngOnInit() {


		$(document).ready(function(){
      $(".testimonials-carousasdel").owlCarousel({
       autoplay: true,
       dots: true,
       loop: true,
       responsive: {
         0: {
           items: 1
         },
         768: {
           items: 2
         },
         900: {
           items: 3
         }
       }
     });


     $(".clients-asdcarousel").owlCarousel({
       autoplay: true,
       dots: true,
       loop: true,
       responsive: {
         0: {
           items: 1
         },
         768: {
           items: 3
         },
         900: {
           items: 3
         }
       }
     });

   });





  }

  loadFooterContent(footer) {
    if (footer.title !== 'Blog') {
      this.router.navigate(['welcome', footer.path]);
    } else {
      window.open('http://blog.statementgames.com', '_self');
    }

  }

}
